import { useEffect, useState } from "react";
import {
  Card,
  CardBody, 
  Spinner
} from "reactstrap";
import { 
  FaGraduationCap
} from "react-icons/fa";

import GroupLearningLocationService from "../Services/GroupLearningLocationService";
import { GroupLearningDashboardDto } from "../types/GroupLearningLocation";

import LearningPreferenceForm from "./LearningPreferenceForm";
import LearningPreferenceView from "./LearningPreferenceView";

interface Props {
  groupId: string;
  isMember: boolean;
}

const LearningPreferenceCard = ({
  groupId,
  isMember,
}: Props) => {
  const [loading, setLoading] = useState(true); 

  const [dashboard, setDashboard] =
    useState<GroupLearningDashboardDto>();

  const [editMode, setEditMode] =
    useState(false);

  useEffect(() => {
    if (!isMember) {
      setLoading(false);
      return;
    }

    loadDashboard();

    // eslint-disable-next-line
  }, [groupId, isMember]);

  const loadDashboard = async () => {
    setLoading(true);

    try {
      const data =
        await GroupLearningLocationService.getDashboard(groupId);

      setDashboard(data);

      setEditMode(false);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (!isMember) return null;

  if (loading)
    return (
      <Card className="border-0 shadow-sm rounded-4 h-100">
        <CardBody
          className="d-flex justify-content-center align-items-center"
          style={{ minHeight: 250 }}
        >
          <Spinner color="primary" />
        </CardBody>
      </Card>
    );

  const showForm =
    !dashboard?.hasSubmitted || editMode;

  return (
    <Card className="border-0 shadow-sm rounded-4 h-100">
      <CardBody className="p-4">

        {/* Header */}

        <div className="d-flex justify-content-between align-items-start mb-4" >

          <div>
            <h4 className="fw-bold mb-1">
              Learning Preference
            </h4>

            <p className="text-muted mb-0">
              Help us negotiate with institutes that
              match your preferred learning mode.
            </p>
          </div>

          <div
            className="rounded-circle bg-primary bg-opacity-10
            d-flex justify-content-center align-items-center"
            style={{
              width: 55,
              height: 55,
            }}
          >
            <FaGraduationCap
              className="text-primary"
              size={24}
            />
          </div>
        </div>

        {/* Quick Options */}

        {/* <div className="row text-center mb-4">

          <div className="col">
            <h6 className="fw-bold text-primary mb-1">
              Online
            </h6>

            <small className="text-muted">
              Classes
            </small>
          </div>

          <div className="col">
            <h6 className="fw-bold text-success mb-1">
              InPerson
            </h6>

            <small className="text-muted">
              Classroom
            </small>
          </div>
         

        </div> */}

        {showForm ? (
          <>
         
              {/* <div className="d-flex justify-content-between align-items-center">

                <div>

                  <h6 className="fw-bold mb-1">
                    {dashboard?.hasSubmitted
                      ? "Update your preference"
                      : "Select your learning preference"}
                  </h6>

                  <small className="text-muted">
                    Your preference helps us negotiate
                    better offers from coaching institutes.
                  </small>

                </div>

                <div>
                  {isExpanded ? (
                    <FaChevronUp />
                  ) : (
                    <FaChevronDown />
                  )}
                </div>

              </div> */}

              <div className="mt-4">

                <LearningPreferenceForm
                  groupId={groupId}
                  dashboard={dashboard}
                  isEdit={
                    dashboard?.hasSubmitted ?? false
                  }
                  onSaved={loadDashboard}
                  onCancel={() =>
                    setEditMode(false)
                  }
                />

              </div>
          </>
        ) : (
          <LearningPreferenceView
            dashboard={dashboard!}
            onUpdated={() =>
              setEditMode(true)
            }
          />
        )}
      </CardBody>
    </Card>
  );
};

export default LearningPreferenceCard;